import ValidationStatusCell from '../../components/validation-status-cell/validation-status-cell'
import {
    validateMarginRatio,
    validateFloods,
    validateCostOfAllCopies,
    validateMaterialWidth,
    validateProfitOfAllCopies,
    validateProfitPerHour,
    validateMaterialEfficiency,
    validateMachine,
} from '../../helpers/validators'
import type { CalculationColumn } from '../../types/column-types'
import type { ValidatorWithLocation } from '../../components/validation-status-cell/validation-status-cell'

const STATUS_VALIDATORS: ValidatorWithLocation[] = [
    { validator: validateMarginRatio, location: 'Коеф. нац.' },
    { validator: validateFloods, location: 'Р' },
    { validator: validateCostOfAllCopies, location: 'Себестоимость тиража' },
    { validator: validateMaterialWidth, location: 'Ширина роля' },
    { validator: validateProfitOfAllCopies, location: 'Прибыль с тиража' },
    { validator: validateProfitPerHour, location: 'Прибыль в 1 час' },
    { validator: validateMaterialEfficiency, location: 'Межэтикетка (м/э)' },
    { validator: validateMachine, location: 'Станок' },
]

export const validationStatusColumn: CalculationColumn = {
    dataIndex: 'validationStatus',
    title: '',
    fixed: 'right',
    width: 16,
    render: (_, record) => (
        <ValidationStatusCell record={record} validators={STATUS_VALIDATORS} />
    ),
    onCell: () => ({ colSpan: 1 }),
}
